import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Button, Flex } from 'antd';

import { isPastDate } from '../../../helpers/date';
import { hasPermission } from '../../../helpers/user';

import { INVITE_STATUS } from '../../../constants/event';
import { PERMISSIONS } from '../../../constants/permissions';
import { TASK_MODAL_MODE } from '../../../constants/task';

function TaskModalFooter({
  currentTask,
  modalMode,
  newTask,
  onAcceptClick,
  onCancelClick,
  onCreateClick,
  onDeclineClick,
  onDeleteClick,
  onDeleteRecurringTasksClick,
  onEditClick,
  onUpdateClick
}) {
  const { user, permissions } = useSelector(state => state.user);

  const isTaskOwner = currentTask?.is_owner;
  const isPast = isPastDate(currentTask?.due_date, user?.timezone);

  return (
    <Flex className="w-full" gap="small" justify="end" key="actions" wrap>
      {modalMode === TASK_MODAL_MODE.VIEW && isTaskOwner && (
        <Flex className="w-full" gap="small" justify="space-between">
          {hasPermission([PERMISSIONS.TASKS.DELETE_OWN], permissions) && (
            <Flex gap="small">
              <Button danger size="large" type="primary" onClick={onDeleteClick}>
                Delete
              </Button>
              {currentTask?.recurring_id && (
                <Button danger size="large" type="primary" onClick={onDeleteRecurringTasksClick}>
                  Delete all recurring tasks
                </Button>
              )}
            </Flex>
          )}
          <Flex gap="small">
            <Button size="large" onClick={onCancelClick}>
              Cancel
            </Button>
            {hasPermission([PERMISSIONS.TASKS.UPDATE_OWN], permissions) && (
              <Button size="large" type="primary" onClick={onEditClick}>
                Edit
              </Button>
            )}
          </Flex>
        </Flex>
      )}

      {modalMode === TASK_MODAL_MODE.UPDATE && isTaskOwner && (
        <Flex gap="small">
          <Button size="large" onClick={onCancelClick}>
            Cancel
          </Button>
          <Button disabled={!newTask.title} size="large" type="primary" onClick={onUpdateClick}>
            Update
          </Button>
        </Flex>
      )}

      {modalMode === TASK_MODAL_MODE.CREATE && (
        <Flex gap="small">
          <Button size="large" onClick={onCancelClick}>
            Cancel
          </Button>
          <Button disabled={!newTask.title} size="large" type="primary" onClick={onCreateClick}>
            Create
          </Button>
        </Flex>
      )}

      {modalMode !== TASK_MODAL_MODE.CREATE && !isTaskOwner && !isPast && (
        <Flex gap="small" justify="space-between">
          <Button size="large" onClick={onCancelClick}>
            Cancel
          </Button>
          <Flex vertical={false} gap="small">
            <Button
              disabled={currentTask?.inviteStatus === INVITE_STATUS.DECLINED}
              danger
              size="large"
              type="primary"
              onClick={onDeclineClick}>
              Decline
            </Button>
            <Button
              disabled={currentTask?.inviteStatus === INVITE_STATUS.ACCEPTED}
              size="large"
              type="primary"
              onClick={onAcceptClick}>
              Accept
            </Button>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}

export default memo(TaskModalFooter);
